import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./App.css";
import AOS from "aos";
import "aos/dist/aos.css";
import { LangProvider } from "./context/Context";


// Initialize AOS after component mount
setTimeout(() => {
  AOS.init({
    duration: 800,
    once: true,
    easing: "ease-out-cubic",
  });
}, 100);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <LangProvider>
      <App />
    </LangProvider>
  </React.StrictMode>
);